// components/LegalTab.jsx
import React from 'react';
import { FileText, Shield, Lock, Cookie, RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const LegalTab = () => {
  const policies = [
    { icon: FileText, label: 'Terms & Conditions' },
    { icon: Shield, label: 'Data Protection Policy' },
    { icon: Lock, label: 'Privacy Policy' },
    { icon: Cookie, label: 'Cookie Policy' },
    { icon: RefreshCw, label: 'Third-Party Services Policy' }
  ];
const navigate = useNavigate()


  const navigateToTerms = ()=>{
    navigate('/termsandconditions')
  }
  return (
    <div className="px-6 pt-10 pb-6 flex flex-col h-full">
      {/* Policy Buttons */}
      <div className="space-y-8">
        {policies.map((policy, index) => {
          const Icon = policy.icon;
          return (
            <button
              key={index}
              onClick={navigateToTerms}
              className="w-full bg-white rounded-lg px-6 py-6 flex items-center gap-5 text-left hover:bg-gray-50 transition-colors"
            >
              <Icon className="w-7 h-7 text-gray-700 flex-shrink-0" />
              <span className="text-[#00D9FF] font-medium text-xl">
                {policy.label}
              </span>
            </button>
          );
        })}
      </div>

      {/* Get More Help Button */}
      <div className="mt-auto mb-4">
        <button className="w-full py-5 bg-transparent text-white border-2 border-white rounded-lg text-xl font-semibold cursor-pointer hover:bg-white hover:text-black transition-colors">
          Get More Help
        </button>
      </div>
    </div>
  );
};

export default LegalTab;